/*
 * This page renders when a student tries to access the trainer on a small device.
 * It utilizes the styles from the onboarding page but isn't restricted to only students in the onboarding flow.
 */
import React, {useCallback} from "react";

import {SceneDialog, sceneDialogStyles} from "../view/SceneDialog";
import * as styles from "./styles/PageOnboarding.module.css";
import {User} from "shared/types/VaultTypes";
import {titleCaseName} from "../../parent/primaryRegistration/studentNameDisplay";
import {MOBILE_SCHOOL_BACKGROUND_IMAGE_URL} from "../../parent/primaryRegistration/schoolBackgroundAsset";
import URLMake from "shared/URLMake";
import AT from "../vault/ActionTypes";
import {useVaultDispatch} from "../top/VaultContext";

const WonkyButton = require("../view/WonkyButton");

type PageStudentScreenWarningProps = {
	user: User;
	fromParent: boolean;
	warning: string;
	isOffice?: boolean;
};

export function PageStudentScreenWarning({
	user,
	fromParent,
	warning,
	isOffice = false,
}: PageStudentScreenWarningProps) {
	const displayName = user.model
		? titleCaseName(user.model.displayName)
		: "there";
	const username = user.model?.username ?? "your username";

	const copy = fromParent ? (
		<>
			{`This works best on a bigger screen. Head to `}
			<span style={{fontWeight: "bold", color: "#0058A8"}}>
				beastacademy.com
			</span>
			{` on a desktop or tablet and log in with ${displayName}'s credentials `}
			<span style={{fontWeight: "bold", color: "#209dc7"}}>{username}</span>
			{`.`}
		</>
	) : (
		<>
			{`Hello, ${displayName}! `}
			{`This works best on a bigger screen. Head to `}
			<span style={{fontWeight: "bold", color: "#0058A8"}}>
				beastacademy.com
			</span>
			{` on a desktop or tablet and log in with `}
			<span style={{fontWeight: "bold", color: "#209dc7"}}>{username}</span>
			{`.`}
		</>
	);
	const dispatch = useVaultDispatch();
	const ignoreWarning = useCallback(() => {
		dispatch({type: AT.IGNORE_SCREEN_WARNING});
	}, [dispatch]);

	let button;
	if (warning !== "rotate") {
		if (isOffice) {
			button = (
				<WonkyButton linkTo={URLMake.forBAOnline()} buttonText="Learn More" />
			);
		} else if (fromParent) {
			button = (
				<WonkyButton
					variant="outline"
					buttonText="Back to Account"
					buttonTextNarrow="Account"
					buttonType="trapFlipped"
					handleClick={() => {
						window.location.href = URLMake.forParent() ?? "";
					}}
				/>
			);
		} else {
			button = <WonkyButton handleClick={ignoreWarning} buttonText="Close" />;
		}
	}

	return (
		<div className={styles.onboarding}>
			<img
				className={styles.backgroundImage}
				src={MOBILE_SCHOOL_BACKGROUND_IMAGE_URL}
				aria-hidden
			/>

			<SceneDialog tabLabel="Headmaster" className={styles.sceneDialogWrapper}>
				<p className={sceneDialogStyles.dialogCopy}>{copy}</p>
				<SceneDialog.Footer>{button}</SceneDialog.Footer>
			</SceneDialog>
		</div>
	);
}
